/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Attach_Tab_PlatformInputs */

const cs_chat_attach_tab_platform = /** @type {(inputs: Chat_Attach_Tab_PlatformInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Z platformy`)
};

const en_chat_attach_tab_platform = /** @type {(inputs: Chat_Attach_Tab_PlatformInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From platform`)
};

/**
* | output |
* | --- |
* | "From platform" |
*
* @param {Chat_Attach_Tab_PlatformInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const chat_attach_tab_platform = /** @type {((inputs?: Chat_Attach_Tab_PlatformInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Attach_Tab_PlatformInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chat_attach_tab_platform(inputs)
	return cs_chat_attach_tab_platform(inputs)
});